import Header from '../components/header';
import Getintouch from '../components/getintouch.js';
import About2 from '../components/about2';
import Services from '../components/services';
import Testimony from '../components/testimony';
import CTO from '../components/calltoaction.js';
import Travelling from '../components/travelling.js';
import Partners from '../components/partners.js';

export default function Home(){
    return (
        <div>
            <Header />
            <Services />
            <About2 />
            <Travelling />
            <CTO />
            <Testimony />
            <Partners />
            <Getintouch />
        </div>
    );
}

var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/62b4f1c67b967b1179963ca5/1g69d0sha';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();
